import React from 'react';
import Styles from './CreationDateLabel.module.less';
import { classes, toReadableDate } from '../../../lib';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';

export const CreationDateLabel = ({
    creationDate,
}: {
    creationDate: DateTime;
}): JSX.Element => {
    return (
        <span className={classes(Styles.label)}>
            <span className="horizontal left-middle g4">
                <FontAwesomeIcon icon={faCalendarAlt} />
                {toReadableDate(creationDate)}
            </span>
        </span>
    );
};
